export default __webpack_public_path__ + "static/media/pattern-002-10.6300db0a.jpg";